import { Link, useLocation } from 'react-router-dom';
import Button from '../ui/shared/button';
import { PAGE_NOT_FOUND_IMAGE } from '../ui/shared/assets';
import './css/404.css';

export default () => {
  const location = useLocation();
  return <div class="row">
    <div class="flex-col">
      <h2>Sorry, the page you are requesting does not exist</h2>
      <span>
        The page "<code>{location.pathname}</code>" could not be found. Please check the URL and try again.
        <Link to="/"><Button>Go to Home page</Button></Link>
      </span>
      <div className="img-404-container">
        <img src={PAGE_NOT_FOUND_IMAGE}/>
      </div>
    </div>
  </div>
};